module.exports = __webpack_public_path__ + "img/gb-logo.70025631.png";